/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:25:23
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title28 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P28 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        <Title28 pageNumber="">伊利单日数字品牌价值涨跌与影响因素-五级情感倾向分类分析
        </Title28>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.des}>
            ①开赛以来，伊利主要以祝贺运动员夺金摘银或打Call为主要传播动作。②截至6日“测试物料提前露出事件”共造成 - 42,400,272DB的数字品牌价值损失
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <Chart isShow options={setChart({
                  label: chartTitle,
                  list: chartList,
                  color: chartColorList
                })} />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P28);



// WEBPACK FOOTER //
// src/routes/visualChart/P28/index.js